export default {
    common: {
        actions: 'Aksi',
        add: 'Tambah',
        edit: 'Edit',
        delete: 'Hapus',
        search: 'Cari',
        reset: 'Reset',
        export: 'Ekspor',
        submit: 'Konfirmasi',
        confirm: 'Konfirmasi',
        cancel: 'Batal',
        enable: 'Aktifkan',
        disable: 'Nonaktifkan',
        expand: 'Perluas/Lipat',
        close: 'Tutup',
        startDate: 'Tanggal Mulai',
        endDate: 'Tanggal Selesai',
        to: 'sampai'
    },
    route: {
        dashboard: 'Sistem Manajemen',
        usermanger:'Pusat Pengguna',
        introduction: 'Ringkasan',
        documentation: 'Dokumentasi',
        permission: 'Halaman Uji Hak Akses',
        pagePermission: 'Hak Akses Halaman',
        directivePermission: 'Hak Akses Direktif',
        icons: 'Ikon',
        components: 'Komponen',
        componentIndex: 'Perkenalan',
        tinymce: 'Editor Teks Kaya',
        markdown: 'Markdown',
        jsonEditor: 'Editor JSON',
        dndList: 'Drag Daftar',
        splitPane: 'Splitpane',
        avatarUpload: 'Unggah Avatar',
        dropzone: 'Dropzone',
        sticky: 'Sticky',
        countTo: 'CountTo',
        componentMixin: 'Komponen Kecil',
        backToTop: 'Kembali ke Atas',
        dragDialog: 'Dialog Drag',
        dragKanban: 'Kanban Dapat Digeser',
        charts: 'Grafik',
        keyboardChart: 'Grafik Keyboard',
        lineChart: 'Grafik Garis',
        mixChart: 'Grafik Campuran',
        example: 'Contoh Komprehensif',
        Table: 'Tabel',
        dynamicTable: 'Tabel Dinamis',
        dragTable: 'Tabel Drag',
        inlineEditTable: 'Edit Dalam Tabel',
        complexTable: 'Tabel Kompleks',
        treeTable: 'Tabel Pohon',
        customTreeTable: 'Tabel Pohon Kustom',
        tab: 'Tab',
        form: 'Formulir',
        createForm: 'Buat Formulir',
        editForm: 'Edit Formulir',
        errorPages: 'Halaman Error',
        page401: '401',
        page404: '404',
        errorLog: 'Log Error',
        excel: 'Excel',
        exportExcel: 'Ekspor Excel',
        selectExcel: 'Ekspor Terpilih',
        uploadExcel: 'Unggah Excel',
        zip: 'Zip',
        exportZip: 'Ekspor Zip',
        theme: 'Tema',
        clipboardDemo: 'Clipboard',
        i18n: 'Internasionalisasi'
    },
    navbar: {
        logOut: 'Keluar Login',
        dashboard: 'Beranda',
        github: 'Alamat Proyek',
        screenfull: 'Layar Penuh',
        theme: 'Tema',
        projectManagement: 'Manajemen Proyek',
        recycleBin: 'Sampah',
        systemManagement: 'Manajemen Sistem',
        userManagement: 'Manajemen Pengguna',
        roleManagement: 'Manajemen Peran',
        menuManagement: 'Manajemen Menu',
        codeGeneration: 'Generasi Kode',
        projectList: 'Daftar Proyek',
        automatedReport: 'Laporan Otomatis',
        favoritesCenter: 'Pusat Favorit',
        collaborativeSurvey: 'Survey Kolaboratif',
        pushCenter: 'Pusat Push',
        systemSettings: 'Pengaturan Sistem'
    },
    login: {
        title: 'Sistem Login',
        logIn: 'Masuk',
        username: 'Nama Pengguna',
         password: 'Kata Sandi',
        any: 'Isi Apa Saja',
        thirdparty: 'Masuk dengan Pihak Ketiga',
        thirdpartyTips: 'Tidak dapat mensimulasikan secara lokal, silakan hubungi pengembang Anda untuk mensimulasikan!!'
    },
    loginPage: {
        kickedTitle: 'Masuk di tempat lain',
        kickedDesc: 'Akun Anda masuk di perangkat lain, sehingga perangkat ini dikeluarkan. Jika bukan Anda, segera ubah kata sandi.',
        loginTitle: 'Masuk',
        username: 'Nama Pengguna',
        usernameLogin: 'Nama Pengguna / No. HP',
        loginModePassword: 'Login Kata Sandi',
        loginModeSms: 'Login Kode SMS',
        loginModeLabel: 'Metode masuk',
        password: 'Kata Sandi',
        forgotPassword: 'Lupa Kata Sandi?',
        login: 'Masuk',
        orLoginWith: 'Atau masuk dengan platform sosial',
        registerTitle: 'Daftar',
        register: 'Daftar',
        orRegisterWith: 'Atau daftar dengan platform sosial',
        hello: 'Halo, Selamat Datang',
        noAccount: 'Belum punya akun?',
        toRegister: 'Daftar',
        welcomeBack: 'Selamat Datang Kembali!',
        hasAccount: 'Sudah punya akun?',
        toLogin: 'Masuk',
        usernameRequired: 'Silakan masukkan nama pengguna',
        usernameInvalid: 'Nama pengguna harus mengandung huruf',
        passwordRequired: 'Silakan masukkan kata sandi',
        loginSuccess: 'Login berhasil',
    },
    documentation: {
        documentation: 'Dokumentasi',
        github: 'Alamat Github'
    },
    // ===== Kolaborasi real-time (WebSocket editor) =====
    collab: {
        online: 'Kolaborator online',
        someone: 'Kolaborator',
        updated: 'memperbarui',
        isEditing: 'sedang mengedit',
        updatedBadge: 'Diperbarui oleh {name}',
        loadLatest: 'Muat terbaru',
        overwrite: 'Timpa dengan milik saya',
        loadLatestBtn: 'Muat versi mereka',
        conflictTitle: 'Konflik penyimpanan',
        conflictDesc: 'Pertanyaan ini telah diubah oleh kolaborator lain. Perubahan Anda belum disimpan.',
        conflictTip: '"Timpa dengan milik saya" mengganti perubahan mereka dengan milik Anda; "Muat versi mereka" membuang perubahan Anda.',
        overwriteSuccess: 'Berhasil ditimpa dan disimpan',
        overwriteFail: 'Gagal menimpa',
        loadedLatest: 'Versi terbaru dimuat',
        reconnecting: 'Kolaborasi real-time terputus, menyambung ulang...',
        degraded: 'Kolaborasi real-time sementara tidak tersedia (mencoba ulang otomatis)'
    },
    permission: {
        roles: 'Hak Anda',
        switchRoles: 'Beralih Hak'
    },
    components: {
        documentation: 'Dokumentasi',
        tinymceTips: 'Editor teks adalah fitur inti dari sistem manajemen backend, namun juga merupakan tempat banyak lubang. Selama proses pemilihan editor teks, saya juga menemukan banyak rute yang salah, dan banyak editor teks yang umum digunakan sudah pernah saya coba, akhirnya saya memutuskan untuk menggunakan Tinymce. Untuk perbandingan dan penjelasan lebih detail tentang editor teks, silakan lihat',
        dropzoneTips: 'Karena kebutuhan bisnis saya memiliki kebutuhan khusus, dan perlu mengirimkan ke tujuh puluh sembilan, jadi saya tidak menggunakan pihak ketiga, dan memilih untuk menutup sendiri. Kode sangat sederhana, Anda dapat melihat kodenya di sini @/components/Dropzone',
        stickyTips: 'Saat halaman di-scroll ke posisi yang ditentukan, akan menempel di bagian atas',
        backToTopTips1: 'Saat halaman di-scroll ke posisi yang ditentukan, tombol kembali ke atas akan muncul di pojok kanan bawah',
        backToTopTips2: 'Tombol dapat disesuaikan dengan gaya, show/hide, tinggi munculnya, dan posisi kembali. Jika Anda ingin teks tip, Anda dapat menggunakan elemen el-tooltip dari Element',
        imageUploadTips: 'Karena saat saya menggunakannya hanya versi vue@1, dan tidak kompatibel dengan mockjs, jadi saya mengubahnya sendiri, jika Anda ingin menggunakannya, sebaiknya gunakan versi resmi terlebih dahulu.'
    },
    table: {
        dynamicTips1: 'Tabel tetap, urutkan sesuai urutan header',
        dynamicTips2: 'Tabel tidak tetap, urutkan sesuai urutan klik',
        dragTips1: 'Urutan default',
        dragTips2: 'Urutan setelah di-drag',
        title: 'Judul',
        importance: 'Keutamaan',
        type: 'Tipe',
        remark: 'Ulasan',
        reviewer: 'Pemeriksa',
        id: 'Nomor',
        date: 'Waktu',
        author: 'Penulis',
        readings: 'Bacaan',
        status: 'Status',
        publish: 'Publikasi',
        draft: 'Draft',
    },
    errorLog: {
        tips: 'Silakan klik ikon keluar bug di sudut kanan atas',
        description: 'Sistem manajemen backend saat ini hampir semuanya berbentuk SPA, yang meningkatkan pengalaman pengguna, namun juga meningkatkan kemungkinan halaman bermasalah. Satu kecil kesalahan bisa menyebabkan keseluruhan halaman mati. Tetapi Vue menyediakan metode untuk menangkap dan menangani pengecualian, Anda dapat melakukan penanganan kesalahan atau pelaporan kesalahan di sana.',
        documentation: 'Dokumentasi Penjelasan'
    },
    excel: {
        export: 'Ekspor',
        selectedExport: 'Ekspor Item Terpilih',
        placeholder: 'Silakan masukkan nama file (default: excel-list)'
    },
    zip: {
        export: 'Ekspor',
        placeholder: 'Silakan masukkan nama file (default: file)'
    },
    theme: {
        change: 'Tema',
        documentation: 'Dokumentasi Tema',
        tips: 'Tips: Ini berbeda dari tema-pick di navbar, ada dua cara berbeda untuk mengubah tema, masing-masing memiliki aplikasi yang berbeda, silakan lihat dokumentasi untuk detail.'
    },
    tagsView: {
        close: 'Tutup',
        closeOthers: 'Tutup Lainnya',
        closeAll: 'Tutup Semua'
    },
    dashboard: {
        kpi: {
            surveyCount: "Jumlah Survei",
            userCount: "Jumlah Pengguna",
            ongoingSurvey: "Survei Berlangsung",
            recoveryRate: "Rasio Pengembalian Survei"
        },
        trend: "Statistik Tren Data",
        client: "Klien",
        browser: "Browser",
        system: "Sistem",
        newSurvey: "Survei Baru",
        announcement: "Pengumuman"
    },
    project: {
        collaborator: {
            sharedWithMe: 'Dibagikan ke saya',
            readonly: 'Hanya lihat',
            share: 'Bagikan',
            view: 'Lihat',
            sharedFrom: 'Dibagikan oleh',
            title: 'Bagikan proyek',
            tip: 'Anggota yang dibagikan dapat melihat konten terbaru proyek ini (pertanyaan, pengaturan, respons, statistik) tetapi tidak dapat mengubahnya.',
            searchPlaceholder: 'Cari berdasarkan akun atau nama (minimal 2 karakter)',
            search: 'Cari',
            searchResult: 'Hasil pencarian',
            invite: 'Undang',
            memberList: 'Anggota yang dibagikan',
            emptyMembers: 'Belum dibagikan kepada siapa pun',
            emptySearch: 'Pengguna tidak ditemukan',
            remove: 'Hapus',
            close: 'Tutup',
            readonlyTip: 'Proyek ini dibagikan kepada Anda dengan akses hanya lihat. Anda dapat melihat isinya tetapi tidak dapat mengubahnya.',
            needKeyword: 'Masukkan minimal 2 karakter',
            inviteSuccess: 'Dibagikan kepada pengguna ini',
            inviteFail: 'Gagal membagikan',
            removeSuccess: 'Anggota dihapus',
            removeFail: 'Gagal menghapus',
            sidebarReadonlyTip: 'Berbagi hanya lihat: dapat dilihat tetapi tidak dapat diubah',
            bannerPrefix: 'Proyek ini dibagikan kepada Anda oleh',
            bannerSuffix: '. Anda dapat melihat semuanya (termasuk respons dan statistik) tetapi tidak dapat mengubahnya.',
            otherUser: 'pengguna lain',
            tip2: 'Anggota yang diundang dapat melihat proyek ini setelah menerima. Setelah diterima mereka dapat melihat pertanyaan, pengaturan, respons dan statistik, tetapi tidak dapat mengubahnya.',
            inviteSent: 'Undangan terkirim, menunggu konfirmasi',
            statusPending: 'Menunggu',
            statusAccepted: 'Bergabung',
            statusRejected: 'Ditolak',
            reinvite: 'Undang lagi',
            invitePanelTitle: 'Anda memiliki undangan berbagi proyek baru',
            collapse: 'Tutup',
            expand: 'Buka',
            invitedBy: 'Dari',
            accept: 'Terima',
            reject: 'Tolak',
            acceptSuccess: 'Undangan diterima, proyek ditambahkan ke daftar Anda',
            acceptFail: 'Gagal menerima undangan',
            rejectSuccess: 'Undangan ditolak',
            rejectFail: 'Gagal menolak undangan',
            searchFailed: 'Pencarian gagal',
            tip3: 'Atur izin per modul: modul "Hanya lihat" hanya dapat dilihat isinya; modul "Dapat diedit" dapat diubah. Berlaku setelah penerima mengonfirmasi; modul yang tidak diizinkan tidak akan terlihat oleh mereka.',
        },
        permission: {
            module: 'Modul',
            none: 'Tanpa akses',
            read: 'Hanya lihat',
            write: 'Dapat diedit',
            editButton: 'Ubah izin',
            configTitle: 'Atur izin',
            configTitleEdit: 'Ubah izin',
            save: 'Simpan',
            saveSuccess: 'Izin diperbarui',
            saveFail: 'Gagal memperbarui izin',
            defaultTip: 'Semua modul default ke "Hanya lihat"; sesuaikan levelnya sebelum mengirim undangan.',
            pureReadOnlyTip: '"Unduh data" dan "Statistik analisis" adalah modul lihat saja dan tidak memiliki level "Dapat diedit".',
            moreItems: '+{n} lainnya',
            modules: {
                design: 'Edit kuesioner',
                setting: 'Pengaturan kuesioner',
                data: 'Data',
                download: 'Unduh data',
                statistics: 'Statistik analisis',
                quota: 'Manajemen kuota',
                publish: 'Publikasi & pengumpulan'
            }
        },
        id: "ID Proyek",
        name: "Nama Proyek",
        status: "Status",
        createTime: "Waktu Pembuatan",
        creator: "Pembuat",
        all: "Semua",
        design: "Desain",
        progress: "Dipublikasikan",
        completed: "Selesai",
        expireOverlayText: 'Proyek telah kedaluwarsa, silakan tutup atau perpanjang',
        extendProject: 'Perpanjang',
        closeProject: 'Tutup',
        extendSuccess: 'Berhasil diperpanjang',
        extendFail: 'Perpanjangan gagal',
        closeSuccess: 'Proyek ditutup',
        closeFail: 'Penutupan gagal',
        closeProjectTitle: 'Tutup Proyek',
        closeProjectTip: 'Tautan survei tidak akan dapat diakses setelah ditutup. Lanjutkan?',
        noData: "Tidak Ada Data",
        stats: "Statistik",
        search: "Pencarian",
        config: {
            config: 'Konfigurasi',
            info: 'Info',
            link: 'Tautan',
            settings: 'Pengaturan',
            thirdParty: 'Konfigurasi Pihak Ketiga',
            language: 'Bahasa',
            display: 'Tampilan',
            status: 'Status',
            quota: 'Kuota',
            baseInfo: 'Info Dasar',
            projectName: 'Nama Proyek',
            projectDescription: 'Deskripsi Proyek',
            organization: 'Organisasi',
            save: 'Simpan',
            linkSettings: 'Pengaturan Tautan',
            surveyLink: 'Tautan Survei',
            shareLink: 'Tautan Berbagi',
            copy: 'Salin',
            baseSettings: 'Pengaturan Dasar',
            surveyStatus: 'Status Survei',
            on: 'Aktifkan',
            off: 'Nonaktifkan',
            allowRepeat: 'Izinkan Mengulang Submisi',
            showProgress: 'Tampilkan Progress Bar',
            thirdPartyIntegration: 'Integrasi Pihak Ketiga',
            wechat: 'Integrasi WeChat',
            workWechat: 'Work WeChat',
            dingtalk: 'DingTalk',
            languageSettings: 'Pengaturan Bahasa',
            defaultLanguage: 'Bahasa Default',
            supportedLanguages: 'Bahasa yang Didukung',
            zhCN: 'Bahasa Mandarin Sederhana',
            enUS: 'Bahasa Inggris',
            displaySettings: 'Pengaturan Tampilan',
            themeColor: 'Warna Tema',
            fontSize: 'Ukuran Huruf',
            showLogo: 'Tampilkan Logo',
            projectStatus: 'Status Proyek',
            currentStatus: 'Status Saat Ini',
            startTime: 'Waktu Mulai',
            endTime: 'Waktu Selesai',
            quotaManage: 'Manajemen Kuota',
            surveyLimit: 'Kuota Survei',
            storageLimit: 'Ruang Penyimpanan',
            apiLimit: 'Jumlah Panggilan API',
            unitMB: 'MB',
            linkCopied: 'Tautan telah disalin ke papan klip',
            saving: 'Konfigurasi telah disimpan',
            ongoing: 'Berlangsung',
            finished: 'Selesai',
            paused: 'Ditunda',
            deleted: 'Dihapus',
        },
        responses: "Respons",
        views: "Tampilan",
        completion: "Rasio Penyelesaian",
        emptyTip: "Tidak Ada Data",
        emptyCreate: "Buat Proyek",
        deleteSuccess: "Hapus Berhasil",
        deleteFail: "Hapus Gagal",
        confirmDelete: "Konfirmasi Hapus",
        confirmDeleteTip: "Apakah Anda yakin ingin menghapus proyek \"{name}\"?",
        createProject: {
            createProject: "Buat Proyek",
            selectType: 'Pilih Tipe Proyek',
            regular: 'Survei Biasa',
            regularDesc: 'Buat proyek survei baru dari awal',
            template: 'Impor Template',
            templateDesc: 'Buat proyek dengan cepat dari template yang ditentukan',
            copy: 'Salin Proyek',
            copyDesc: 'Buat salinan dari proyek yang ada',
            ai: 'AI Parsing',
            aiDesc: 'Gunakan AI untuk secara otomatis menghasilkan struktur survei',
            aiBadge: 'Versi Uji',
            downloadExcelTemplate: 'Unduh Template File Excel',
            downloadJsonTemplate: 'Unduh Template File JSON',
            uploadTip: 'Taruh file di sini, atau',
            clickUpload: 'Klik untuk mengunggah',
            uploadNotice: 'Perhatikan: Silakan unggah file excel, json',
            searchProject: 'Cari Proyek',
            search: 'Pencarian',
            keepLogic: 'Pertahankan Logika',
            keepScript: 'Pertahankan Skrip',
            createTime: 'Waktu Pembuatan:',
            questionCount: 'Jumlah Pertanyaan:',
            aiPlaceholder: 'Silakan masukkan deskripsi tentang survei yang ingin Anda buat, misalnya: Buat survei kepuasan karyawan, termasuk lingkungan kerja, gaji, dan perkembangan karir.',
            aiStart: 'Mulai Parsing',
            aiClear: 'Kosongkan',
            aiTip1: 'AI akan secara otomatis menghasilkan struktur survei berdasarkan deskripsi Anda',
            aiTip2: 'Deskripsi semakin detail, struktur survei yang dihasilkan semakin akurat',
            info: 'Info Proyek',
            name: 'Nama Proyek',
            namePlaceholder: 'Silakan masukkan nama proyek',
            organization: 'Organisasi',
            organizationPlaceholder: 'Silakan masukkan organisasi',
            description: 'Deskripsi Proyek',
            descriptionPlaceholder: 'Silakan masukkan deskripsi proyek',
            cancel: 'Batal',
            create: 'Buat Proyek',
            uploadTemplate: 'Silakan unggah file template',
            selectCopyProject: 'Pilih proyek yang akan disalin',
            aiInputRequired: 'Silakan masukkan deskripsi konten AI',
            aiParseRequired: 'Silakan lakukan parsing AI terlebih dahulu',
            createSuccess: 'Proyek berhasil dibuat',
            createFail: 'Gagal membuat proyek',
            createFailRetry: 'Gagal membuat proyek, silakan coba lagi nanti',
        },
    },
    recycle: {
        title: "Sampah",
        id: "ID Proyek",
        name: "Nama Proyek",
        deletedAt: "Waktu Penghapusan",
        createdAt: "Waktu Pembuatan",
        creator: "Pembuat",
        restore: "Kembalikan",
        noData: "Tidak Ada Data",
        confirmDelete: "Hapus Permanen",
        confirmDeleteTip: "Apakah Anda yakin ingin menghapus proyek ini secara permanen? Operasi ini tidak dapat dibatalkan.",
        restoreSuccess: "Kembalikan Berhasil",
        restoreFail: "Kembalikan Gagal",
        deleteSuccess: "Hapus Berhasil",
        deleteFail: "Hapus Gagal"
    },
    user: {
        title: "Manajemen Pengguna",
        id: "ID Pengguna",
        name: "Nama Pengguna",
        mobile: "Nomor Telepon Pengguna",
        email: "Email Pengguna",
        avatar: "Avatar Pengguna",
        confirmDelete: "Apakah Anda yakin ingin menghapus item data dengan ID pengguna \"{id}\"?",
        addTitle: "Tambah Pengguna",
        editTitle: "Edit Info Pengguna",
        uploadAvatar: "Ganti Avatar",
        uploadSuccess: "Unggah Berhasil!",
        uploadFail: "Unggah Gagal: {msg}",
        uploadTypeError: "Gambar avatar hanya boleh JPG/PNG!",
        uploadSizeError: "Ukuran gambar avatar tidak boleh lebih dari 2MB!",
        placeholderName: "Silakan masukkan nama pengguna",
        placeholderMobile: "Silakan masukkan nomor telepon pengguna",
        placeholderEmail: "Silakan masukkan email pengguna",
        placeholderAvatar: "Silakan masukkan tautan avatar pengguna"
    },
    role: {
        title: "Manajemen Peran",
        id: "Nomor Peran",
        name: "Nama Peran",
        key: "Hak Karakter",
        sort: "Urutan Tampilan",
        status: "Status",
        createTime: "Waktu Pembuatan",
        remark: "Catatan",
        menuPerm: "Hak Akses Menu",
        dataPerm: "Hak Akses Data",
        assignUser: "Tugaskan Pengguna",
        more: "Lebih Banyak",
        confirmDelete: "Apakah Anda yakin ingin menghapus item data dengan ID peran \"{id}\"?",
        addTitle: "Tambah Peran",
        editTitle: "Edit Peran",
        dataScope: "Jangkauan Hak",
        allData: "Hak Akses Data Lengkap",
        customData: "Hak Akses Data Kustom",
        deptData: "Hak Akses Data Departemen",
        deptBelowData: "Hak Akses Data Departemen dan di bawahnya",
        selfData: "Hak Akses Data Sendiri",
        selectAll: "Pilih Semua/Tidak Pilih Semua",
        parentLink: "Tautan Bapak/Anak",
        loading: "Memuat, Silakan Tunggu",
        remarkPlaceholder: "Silakan masukkan konten",
        successAdd: "Berhasil Ditambahkan",
        successEdit: "Berhasil Diperbarui",
        successDelete: "Berhasil Dihapus",
        successStatus: "{action} Berhasil",
        confirmStatus: "Apakah Anda yakin ingin mengubah peran \"{name}\" menjadi {action}?",
        assignDataPerm: "Tugaskan Hak Akses Data",
        assignUserTitle: "Tugaskan Pengguna",
        cancelAuth: "Batalkan Izin",
        batchCancelAuth: "Batalkan Izin Batch",
        closePage: "Tutup",
        selectUser: "Pilih Pengguna",
        selectUserTip: "Silakan pilih pengguna yang akan ditugaskan",
        selectUserSuccess: "Berhasil Ditugaskan"
    },
    menu: {
        title: "Manajemen Menu",
        name: "Nama Menu",
        icon: "Ikon",
        sort: "Urutan",
        perms: "Identitas Hak",
        component: "Jalur Komponen",
        status: "Status",
        createTime: "Waktu Pembuatan",
        confirmDelete: "Apakah Anda yakin ingin menghapus item data dengan nama \"{name}\"?",
        addTitle: "Tambah Menu",
        editTitle: "Edit Menu",
        successAdd: "Berhasil Ditambahkan",
        successEdit: "Berhasil Diperbarui",
        successDelete: "Berhasil Dihapus",
        placeholderName: "Silakan masukkan nama menu",
        placeholderRouteName: "Silakan masukkan nama rute",
        placeholderPath: "Silakan masukkan alamat rute",
        placeholderComponent: "Silakan masukkan jalur komponen",
        placeholderPerms: "Silakan masukkan identitas hak",
        placeholderQuery: "Silakan masukkan parameter rute",
        placeholderIcon: "Pilih ikon",
        placeholderParentMenu: "Pilih menu induk",
        parentMenu: "Menu Induk",
        menuType: "Tipe Menu",
        directory: "Direktori",
        menu: "Menu",
        button: "Tombol",
        menuIcon: "Ikon Menu",
        displaySort: "Urutan Tampilan",
        routeName: "Nama Rute",
        routeNameTip: "Jika tidak diisi, akan sama dengan alamat rute: misalnya, jika alamatnya adalah: `user`, maka namanya adalah `User` (perhatikan: jika perlu, silakan kustomisasi untuk menghindari konflik nama, pastikan keunikan) ",
        isExternalLink: "Apakah Tautan Luar?",
        externalLinkTip: "Jika pilih tautan luar, alamat rute perlu diawali dengan `http(s)://`",
        routeAddress: "Alamat Rute",
        routeAddressTip: "Alamat rute yang diakses, misalnya: `user`, jika alamat internet perlu diakses secara internal, maka perlu diawali dengan `http(s)://`",
        componentPath: "Jalur Komponen",
        componentPathTip: "Jalur komponen yang diakses, misalnya: `system/user/index`, secara default berada di direktori `views`",
        permissionChar: "Hak Karakter",
        permissionCharTip: "Hak karakter yang didefinisikan dalam kontroler, misalnya: @PreAuthorize(`@ss.hasPermi('system:user:list')`)",
        routeParams: "Parameter Rute",
        routeParamsTip: "Parameter default yang akan dikirimkan melalui rute, misalnya: `{\"id\": 1, \"name\": \"ry\"}`",
        displayStatus: "Status Tampilan",
        displayStatusTip: "Jika pilih tersembunyi, rute tidak akan muncul di sidebar, tetapi masih dapat diakses",
        menuStatus: "Status Menu",
        menuStatusTip: "Jika pilih nonaktif, rute tidak akan muncul di sidebar, dan tidak dapat diakses",
        yes: "Ya",
        no: "Tidak",
        mainCategory: "Kategori Utama",
        nameRequired: "Nama menu tidak boleh kosong",
        sortRequired: "Urutan menu tidak boleh kosong",
        pathRequired: "Alamat rute tidak boleh kosong"
    },
    header: {
        lang: {
            zh: 'Bahasa Mandarin Sederhana',
            zh_TW: 'Bahasa Mandarin Tradisional',
            en: 'Bahasa Inggris',
            jp: 'Bahasa Jepang',
            ko: 'Bahasa Korea',
            id: 'Bahasa Indonesia',
        },
        helpDoc: 'Dokumentasi Bantuan'
    },
    questionEdit: {
        readonlyLocked: 'Proyek ini hanya lihat, konten tidak dapat diubah',
        // 题型名称
        sortQuestion: 'Pertanyaan Urutan',
        singleQuestion: 'Pertanyaan Pilihan Tunggal',
        multiQuestion: 'Pertanyaan Pilihan Ganda',
        numberQuestion: 'Pertanyaan Nilai',
        textQuestion: 'Pertanyaan Teks',
        dateQuestion: 'Pertanyaan Tanggal',
        timeQuestion: 'Pertanyaan Waktu',
        uploadQuestion: 'Pertanyaan Upload',
        scoreQuestion: 'Pertanyaan Penilaian',
        openQuestion: 'Pertanyaan Terbuka',
        timestampQuestion: 'Timestamp',
        selectQuestion: 'Pertanyaan Pilihan',
        cascadeLevelLabel: 'Level {level} Opsi',
        cascadeOptionsManagement: 'Manajemen Opsi Bertingkat',
        placeholderHint: 'Placeholder: ',
        placeholderInput: 'Silakan masukkan placeholder untuk level {level}',
        manageOptions: 'Kelola Opsi',
        manageSubOptions: 'Kelola Sub-opsi',
        subOptionNamePlaceholder: 'Silakan masukkan nama sub-opsi',
        optionTextLabel: 'Teks Opsi',
        optionCodeLabel: 'Kode Opsi',
        optionTextPlaceholder: 'Silakan masukkan teks opsi',
        optionCodePlaceholder: 'Silakan masukkan kode opsi',
        optionCodeDuplicate: 'Kode opsi duplikat ditemukan di level {level}',
        optionCodeDuplicateGlobal: 'Ditemukan kode opsi duplikat. Harap perbaiki sebelum menyimpan',
        optionValueDuplicate: 'Nilai opsi tidak boleh duplikat dalam pertanyaan ini',
        publishOptionCodeDuplicate: 'Kode opsi duplikat ditemukan di: {questions}. Harap perbaiki sebelum mempublikasikan',
        matrixSingleQuestion: 'Pertanyaan Matriks Pilihan Tunggal',
        matrixMultiQuestion: 'Pertanyaan Matriks Pilihan Ganda',
        matrixBlankQuestion: 'Pertanyaan Matriks Isian Kosong',
        matrixCompositionQuestion: 'Pertanyaan Matriks Komposit',
        matrix: {
            exportOrientation: 'Orientasi',
            perRow: 'Baris',
            perCol: 'Kolom',
            exclusiveLabel: 'Tidak ada di atas',
            exclusiveNone: 'Mati',
            exclusiveRow: 'Hanya baris',
            exclusiveCol: 'Hanya kolom',
            exclusiveBoth: 'Baris + kolom',
            transposeStructure: 'Transposisi struktur pertanyaan',
            total: 'Total'
        },
        thermodynamicChartQuestion: 'Pertanyaan Grafik Termodinamika',
        combinationQuestion: 'Pertanyaan Kombinasi',

        // 特殊题型
        specialComponents: 'Komponen Khusus',
        loopQuestion: 'Pertanyaan Loop',

        // 通用操作
        delete: 'Hapus',
        clear: 'Kosongkan',
        addOption: 'Tambah Opsi',
        batchAdd: 'Tambah Batch',
        batchAddTitle: 'Tambah Opsi Sekaligus',
        batchAddHint: 'Satu opsi per baris. Saat menempel dua kolom dari Excel, kolom angka otomatis dikenali sebagai nilai opsi; tanpa tab, format "1 teks opsi" yang dipisah spasi juga didukung. Hasil pembacaan ditampilkan di bawah dan dapat digeser untuk mengatur urutan akhir.',
        batchAddPlaceholder: '1\tOpsi A\n2\tOpsi B\n3\tOpsi C',
        batchAddParsedCount: '{count} opsi terdeteksi',
        batchAddPreviewTitle: 'Urutan akhir setelah ditambahkan',
        batchAddPreviewEmpty: 'Tempel konten untuk melihat daftar opsi lengkap setelah ditambahkan',
        batchAddTagNew: 'Baru',
        batchAddDragTip: 'Geser di mana saja pada baris untuk mengurutkan; nilai dan teks opsi dapat langsung diubah',
        batchAddValueTaken: 'Nilai {input} sudah dipakai opsi lain pada pertanyaan ini, diubah menjadi {value}',
        batchAddValueInvalid: 'Nilai {input} bukan bilangan bulat positif yang valid, diubah menjadi {value}',
        batchAddValueAdjustedTip: '{count} opsi memiliki nilai duplikat atau tidak valid dan telah diganti dengan nilai yang belum terpakai. Arahkan kursor ke ikon kuning pada baris untuk melihat alasannya, atau ubah langsung ke nilai yang Anda inginkan.',
        batchAddRowErrorSummary: '{count} baris perlu diperbaiki sebelum dapat dikonfirmasi',
        batchAddRichHint: 'Opsi ini memuat teks berformat; di sini hanya teks biasa yang ditampilkan. Biarkan tanpa perubahan untuk mempertahankan format aslinya',
        batchAddWhitespaceHint: 'Teks opsi ini memiliki spasi di awal/akhir yang dipertahankan dan ikut tampil ke responden',
        batchAddModeTab: 'Dipisah tab',
        batchAddModeSpace: 'Dipisah spasi',
        batchAddModeTextOnly: 'Seluruh baris sebagai teks opsi',
        batchAddSuccess: '{count} opsi ditambahkan',
        batchAddExistingCount: '{count} opsi lama',
        batchAddRemoveExisting: 'Hapus opsi lama',
        batchAddRemoveExistingHint: 'Hapus semua opsi lama sekaligus, sisakan hanya yang ditempel kali ini',
        batchAddRestoreRemoved: 'Pulihkan {count}',
        batchAddRestoreRemovedHint: 'Kembalikan opsi lama yang baru dihapus ke posisi semula',
        batchAddRemoveRowHint: 'Hapus baris ini (opsi lama juga bisa dihapus)',
        batchAddPreviewEmptyAfterRemove: '{count} opsi lama sudah dihapus semua. Tempel opsi baru untuk melanjutkan, atau klik 「Pulihkan」 di atas',
        batchAddNeedOneOption: 'Minimal harus ada 1 opsi di pratinjau',
        batchAddSuccessMixed: '{added} opsi ditambahkan, {removed} dihapus',
        batchDelete: 'Hapus Batch',
        batchSelectAll: 'Pilih Semua',
        batchSelectOption: 'Pilih opsi ini',
        batchSelectedCount: '{count} dipilih',
        batchDeleteSelected: 'Hapus Terpilih',
        batchDeleteConfirmMessage: 'Hapus {count} opsi yang dipilih? Anda dapat memulihkannya dengan Batalkan.',
        batchDeleteSuccess: '{count} opsi dihapus',
        batchSelectAllRows: 'Pilih semua baris',
        batchSelectAllCols: 'Pilih semua kolom',
        batchSelectRow: 'Pilih baris ini',
        batchSelectColumn: 'Pilih kolom ini',
        batchSelectedMatrixCount: '{rows} baris · {cols} kolom dipilih',
        batchDeleteConfirmMatrix: 'Hapus {rows} baris dan {cols} kolom yang dipilih? Anda dapat memulihkannya dengan Batalkan.',
        batchDeleteSuccessMatrix: '{rows} baris dan {cols} kolom dihapus',
        clearConfirmCount: 'Total {count} pertanyaan',
        loadingMoreQuestions: 'Memuat pertanyaan berikutnya…',
        loadedProgress: '{loaded} dari {total} pertanyaan dimuat, klik untuk memuat lagi',
        richText: 'Teks Kaya',
        confirm: 'Konfirmasi',
        cancel: 'Batal',

        // 占位符
        optionPlaceholder: 'Silakan masukkan opsi',
        numberPlaceholder: 'Silakan masukkan angka',
        textPlaceholder: 'Silakan masukkan teks',
        datePlaceholder: 'Silakan pilih tanggal',
        timePlaceholder: 'Silakan pilih waktu',
        scorePlaceholder: 'Silakan beri nilai',
        uploadPlaceholder: 'Klik unggah atau taruh file di sini',
        dateFormat: 'Format Tanggal Waktu',
        inputQuestionNo: 'Silakan masukkan nomor pertanyaan',
        scriptType: 'Jenis Skrip',
        tags: 'Tag',
        previewDialog: {
            devicePhone: 'Ponsel',
            deviceTablet: 'Tablet',
            devicePc: 'PC'
        },

        // 搜索与跳转
        searchPlaceholder: 'Silakan masukkan kata kunci',
        quickJump: 'Loncat Cepat',
        searchAndJump: 'Cari soal lalu pilih untuk lompat',
        refreshOutline: 'Segarkan Outline',
        order: 'Urutan',
        orderImportExport: 'Urutan Nomer Soal Impor/Ekspor',

        // 提示消息
        saveSuccess: 'Berhasil Disimpan',
        finishConfirmTitle: 'Setel Proyek ke Selesai',
        finishConfirmMessage: 'Setelah status proyek diatur menjadi "Selesai", survei online akan dikunci dan tidak dapat dijawab atau diedit lagi. Lanjutkan?',
        finishConfirmButton: 'Simpan dan Kunci',
        saveFail: 'Gagal Disimpan',
        deleteSuccess: 'Berhasil Dihapus',
        deleteFail: 'Gagal Dihapus',
        uploadSuccess: 'Berhasil Diunggah',
        uploadFail: 'Gagal Diunggah',
        emptyOptionError: 'Konten opsi tidak boleh kosong',
        optionValueEmpty: 'Nilai opsi tidak boleh kosong atau 0',
        optionEmptyReverted: 'Konten opsi kosong, teks sebelumnya dipulihkan. Gunakan tombol hapus untuk menghapusnya.',
        addQuestionSuccess: 'Pertanyaan berhasil ditambahkan',
        undo: 'Batalkan',
        undoSuccess: 'Perubahan terakhir dibatalkan',
        undoNoChange: 'Tidak ada perubahan untuk dibatalkan',
        undoFailed: 'Gagal membatalkan, silakan coba lagi',
        switchLanguageSuccess: 'Berhasil Mengubah Bahasa',
        maxFilesExceeded: 'Hanya dapat mengunggah {max} file',
        fileSizeExceeded: 'Ukuran file tidak boleh lebih dari {size}MB',

        // 编辑相关
        newOption: 'Opsi Baru',
        editTitle: 'Edit Judul',
        editOption: 'Edit Opsi',
        deleteConfirm: 'Apakah Anda yakin?',
        deleteConfirmTitle: 'Konfirmasi Hapus',
        titleMarkupLostTitle: 'Judul mengandung format',
        titleMarkupLostMessage: 'Judul ini mengandung format rich-text. Menyimpan teks biasa akan menghapus format tersebut. Lanjutkan? (Anda juga dapat mengklik "Rich Text" untuk mempertahankan format.)',
        addNoneOfAbove: 'Tambah "Tidak ada di atas"',
        noneOfAbove: 'Tidak ada di atas',
        exclusiveTag: 'Pilih satu',
        exclusiveTagTip: 'Pilih satu: memilih ini akan menghapus pilihan lainnya',
        exclusiveRemoveTip: 'Klik untuk menghapus aturan',
        exclusiveExists: 'Aturan pilih satu sudah ada',
        exclusiveRemoveConfirm: 'Hapus aturan "pilih satu" ini?',
        exclusiveRemoved: 'Aturan pilih satu dihapus',
        exclusiveAdded: 'Aturan pilih satu ditambahkan',
        exclusiveLogicSaveFailed: 'Gagal menyimpan aturan pilih satu. Tambahkan manual di tab Logika.',

        // Kutip jawaban (sisipkan jawaban pertanyaan sebelumnya ke judul)
        answerRef: {
            button: 'Kutip jawaban',
            buttonTip: 'Sisipkan jawaban pertanyaan sebelumnya ke judul',
            title: 'Kutip jawaban pertanyaan sebelumnya',
            subtitle: 'Sisipkan jawaban pertanyaan sebelumnya ke judul. Saat dijawab, akan otomatis diganti dengan pilihan responden.',
            search: 'Cari nomor atau judul pertanyaan…',
            empty: 'Tidak ada pertanyaan sebelumnya untuk dikutip',
            loading: 'Memuat pertanyaan…',
            disabled: 'Tidak didukung',
            disabledTip: 'Tipe pertanyaan ini belum dapat dikutip',
            quickInsert: 'Sisipkan',
            modes: 'Jenis kutipan',
            modeWhole: 'Seluruh jawaban',
            modeWholeDesc: 'Kutip seluruh jawaban responden untuk pertanyaan ini',
            modeOther: 'Isi "Lainnya"',
            modeOtherDesc: 'Hanya kutip teks yang diketik di "Lainnya"',
            modeItem: 'Item ke-{n}',
            modeRow: 'Baris {n}',
            modeCell: 'Baris {r}, kolom {c}',
            modeItemTitle: 'Item terpilih ke-N',
            modeItemDesc: 'Kutip item ke-N yang dipilih pada pertanyaan pilihan ganda/peringkat',
            modeRowTitle: 'Baris',
            modeRowDesc: 'Kutip jawaban untuk baris matriks ini',
            modeCellTitle: 'Sel',
            modeCellDesc: 'Kutip jawaban untuk sel matriks ini',
            rowPick: 'Pilih baris',
            cellPick: 'Klik sel pada tabel',
            otherPick: 'Pilih "Lainnya" yang mana',
            itemPick: 'Pilih nomor item',
            preview: 'Contoh',
            previewPrefix: 'Pratinjau: ',
            unanswered: 'Jika tidak dijawab: {text}',
            unansweredSample: '[Tidak dijawab]',
            insert: 'Sisipkan ke judul',
            cancel: 'Batal',
            inserted: 'Dikutip',
            dragHint: 'Seret chip di judul untuk mengatur posisi',
            broken: 'Kutipan tidak valid',
            removeRef: 'Hapus kutipan ini',
            brokenTip: 'Pertanyaan ini telah dihapus atau nomornya berubah',
            noPreview: 'Pilih pertanyaan di kiri untuk melihat opsi'
        },
        collapse: 'Lipat',
        valueLabel: 'Nilai:',
        otherLabel: 'Lainnya:',
        netLabel: 'Grup:',
        netNone: '-',
        netGroup: 'Grup NET',
        netGroupPlaceholder: 'Masukkan nama grup',

        // 默认值
        defaultTitle: 'Pertanyaan Baru',
        defaultOption: 'Opsi {index}',
        
        //父组件
        // ===== 以下为design父组件template新增key，重复的也保留，后续可微调 =====
        edit: 'Edit',
        save: 'Simpan',
        statistics: 'Statistik',
        data: 'Data',
        download: 'Unduh',
        publish: 'Publikasikan',
        projectFile: 'File Proyek',
        questionType: 'Tipe Pertanyaan',
        outline: 'Rangkuman',
        questionBank: 'Bank Pertanyaan',
        basicComponents: 'Komponen Dasar',
        advancedComponents: 'Komponen Lanjutan',
        myQuestionBank: 'Bank Pertanyaan Saya',
        add: 'Tambah',
        comprehensiveCustomerSatisfactionSurvey: 'Survey Kepuasan Pelanggan Komprehensif',
        publicQuestionBank: 'Bank Pertanyaan Publik',
        standardQuestionBankGroup: 'Grup Bank Pertanyaan Standar',
        standardTextQuestion: 'Pertanyaan Teks Standar',
        standardSingleChoiceQuestion: 'Pertanyaan Pilihan Tunggal Standar',
        standardMultipleChoiceQuestion: 'Pertanyaan Pilihan Ganda Standar',
        standardOpenQuestion: 'Pertanyaan Terbuka Standar',
        standardRatingQuestion: 'Pertanyaan Penilaian Standar',
        specialQuestionBankGroup: 'Grup Bank Pertanyaan Istimewa',
        specialTextQuestion: 'Pertanyaan Teks Istimewa',
        otherQuestionBankGroup: 'Grup Bank Pertanyaan Lainnya',
        set: 'Atur',
        thenExecutionActions: 'Aksi Eksekusi THEN',
        beforeExecution: 'Sebelum Eksekusi',
        duringExecution: 'Selama Eksekusi',
        afterExecution: 'Setelah Eksekusi',
        favoriteScript: 'Skrip Favorit',
        personal: 'Pribadi',
        details: 'Detail',
        
        tabSetting: 'Atur',
        tabLogic: 'Logika',
        tabScript: 'Skrip',
        options: 'Opsi',
        moreConfig: 'Konfigurasi Lebih Lanjut',
        lengthPx: 'Panjang (px):',
        widthPercent: 'Lebar (%):',
        minLength: 'Jumlah Karakter Minimum:',
        maxLength: 'Jumlah Karakter Maksimum:',
        minNumber: 'Nilai Minimum:',
        maxNumber: 'Nilai Maksimum:',
        allowChar: 'Karakter:',
        allowNumber: 'Nilai:',
        allowDecimal: 'Desimal:',
        decimalPlaces: 'Tempat Desimal:',
        fontSelect: 'Pilih Huruf',
        fontSize: 'Ukuran Huruf',
        optionSize: 'Ukuran Opsi',
        layoutDirection: 'Arah Tata Letak',
        horizontal: 'Horizontal',
        vertical: 'Vertikal',
        rowCount: 'Jumlah Baris',
        rowWidth: 'Lebar Baris',
        colCount: 'Jumlah Kolom',
        colHeight: 'Tinggi Kolom',
        hideImage: 'Sembunyikan Gambar',
        operate: 'Operasi',
        saveLogic: 'Simpan Logika',
        logicList: 'Daftar Logika',
        selectCondition: 'Pilih Kondisi',
        selectOption: 'Pilih Opsi',
        inputValue: 'Silakan masukkan nilai',
        selectRelation: 'Pilih Hubungan',
        priority: 'Prioritas',
        selectAction: 'Pilih Aksi',
        inputText: 'Silakan masukkan teks',
        inputLink: 'Silakan masukkan tautan lompat',
        inputQuestionTitle: 'Silakan masukkan judul pertanyaan baru',
        selectRowCol: 'Pilih Baris/Kolom',
        row: 'Baris',
        column: 'Kolom',
        selectRowOption: 'Pilih Opsi Baris',
        selectColOption: 'Pilih Opsi Kolom',
        searchScript: 'Cari Skrip',
        detail: 'Detail',
        scriptEdit: 'Edit Skrip',
        scriptDetail: 'Detail Skrip',
        search: 'Pencarian',
        questionNo: 'Nomor Pertanyaan',
        logicSettings: 'Pengaturan Logika',
        refreshLogic: 'Segarkan Logika',
        addLogic: 'Tambah Logika',
        ifConditionSettings: 'Pengaturan Kondisi IF',
        favoriteScriptList: 'Daftar Skrip Favorit',
        public: 'Publik',
        apply: 'Terapkan',
        saveScript: 'Simpan Skrip',
        optionContent: 'Konten Opsi',
        tabMoreSetting: 'Atur',
        tabMoreDisplay: 'Tampilkan',
        tabMoreImage: 'Gambar',
        fontMicrosoftYaHei: 'Microsoft YaHei',
        fontSimSun: 'SimSun',
        fontSimHei: 'SimHei',
        fontArial: 'Arial',
        Statistics: {
            dashboardTitle: 'Dashboard Analisis Data',
            effectiveCount: 'Jumlah Pengembalian Efektif',
            totalCount: 'Jumlah Survei Total',
            recoveryRate: 'Rasio Pengembalian',
            avgTime: 'Waktu Penyelesaian Rata-rata',
            deviceModel: 'Model Perangkat',
            dailyTrend: 'Tren Pengumpulan Harian',
            respondentLocation: 'Lokasi Responden Berdasarkan Wilayah',
            briefRecordList: 'Daftar Rekapitulasi Singkat',
            projectId: 'ID Proyek',
            ipAddress: 'Alamat IP',
            deviceType: 'Model Perangkat',
            time: 'Waktu',
            duration: 'Waktu',
            singleChoiceTitle: 'Distribusi Jawaban Pertanyaan Pilihan Tunggal',
            singleChoiceOption: 'Distribusi Opsi',
            multipleChoiceTitle: 'Distribusi Jawaban Pertanyaan Pilihan Ganda',
            multipleChoicePeople: 'Jumlah Orang yang Memilih',
            optionA: 'Opsi A',
            optionB: 'Opsi B',
            optionC: 'Opsi C',
            optionD: 'Opsi D',
            china: 'China',
            usa: 'Amerika Serikat',
            europe: 'Eropa',
            asiaOther: 'Asia Lainnya',
            other: 'Lainnya',
            ios: 'iOS',
            android: 'Android',
            windows: 'Windows',
            mac: 'Mac',
        },
        dataView: {
            listTitle: 'Daftar Jawaban',
            id: 'ID',
            projectId: 'ID Proyek',
            question: 'Pertanyaan',
            answer: 'Jawaban',
            time: 'Waktu',
            duration: 'Waktu',
            ipAddress: 'Alamat IP',
            actions: 'Operasi',
            edit: 'Edit',
            editAnswer: 'Edit Jawaban',
            cancel: 'Batal',
            save: 'Simpan',
            audioList: 'Daftar Audio',
        },
        downloadView: {
            exportOptions: 'Opsi Ekspor',
            exportOptionsSubtitle: 'Pilih format dan opsi ekspor',
            fileFormat: 'Format File',
            exportOptionsTitle: 'Opsi Ekspor',
            dateRange: 'Rentang Waktu',
            startDatePlaceholder: 'Tanggal Mulai',
            endDatePlaceholder: 'Tanggal Selesai',
            startExport: 'Mulai Ekspor',
            excel: 'Excel',
            excelDesc: 'Cocok untuk analisis dan pemrosesan data',
            csv: 'CSV',
            csvDesc: 'Format umum, kompatibel dengan semua perangkat',
            pdf: 'PDF',
            pdfDesc: 'Cocok untuk dicetak dan dibagikan',
            json: 'JSON',
            jsonDesc: 'Cocok untuk pengembang dan integrasi sistem',
            spss: 'SPSS',
            spssDesc: 'Cocok untuk perangkat lunak analisis statistik',
            audio: 'Audio',
            audioDesc: 'Unduh semua rekaman secara massal',
            image: 'Gambar',
            imageDesc: 'Unduh semua file soal unggahan secara massal',
            includeAnswerTime: 'Sertakan Waktu Jawaban',
            includeDeviceInfo: 'Sertakan Info Perangkat',
            includeIpAddress: 'Sertakan Alamat IP',
            includeLocation: 'Sertakan Lokasi Geografis',
            includeUserId: 'Sertakan Identitas Pengguna',
            includeAnswerType: 'Sertakan Jenis Jawaban',
            includeQuestionAnswers: 'Sertakan Jawaban Pertanyaan',
            exportImageAnswer: 'Ekspor Jawaban Gambar',
        },
        publishProject: {
            title: 'Publikasikan Proyek',
            historyLink: 'Tautan Sejarah',
            generateLink: 'Buat Tautan',
            moreLinks: 'Tautan Lainnya',
            linkGenerator: 'Generator Tautan Survei',
            fixedLink: 'Buat Tautan Tetap',
            prod1: 'Tautan Resmi 1',
            prod1Tip: 'Dengan guid dan kontrol IP',
            prod2: 'Tautan Resmi 2',
            prod2Tip: 'Kontrol ID Survei',
            test: 'Tautan Uji Coba',
            testTip: 'Dengan navigasi, tombol sebelumnya',
            ipCtrlDeveloping: 'Fitur kontrol IP masih dalam pengembangan',
            breakpointAutoCheckedTip: 'Saat {source} dipilih, kontrol breakpoint jawaban akan dicentang otomatis',
            breakpointControlledTip: 'Kontrol breakpoint jawaban tidak bisa dicentang langsung. Aktifkan kontrol GUID atau ID survei terlebih dahulu',
            offline: 'Tautan Offline',
            offlineTip: 'Tautan Offline',
            custom: 'Tautan Kustom',
            customTip: 'Tautan Kustom',
            customLink: 'Buat Tautan Kustom',
            accessControl: 'Kontrol Akses',
            ipCtrl: 'Kontrol IP',
            guidCtrl: 'Kontrol GUID',
            surveyIdCtrl: 'Kontrol ID Survei',
            breakpointCtrl: 'Kontrol Breakpoint Jawaban',
            displayOptions: 'Opsi Tampilan',
            showNav: 'Tampilkan Navigasi',
            showPrev: 'Tampilkan Tombol Sebelumnya',
            offlineSubmit: 'Laporkan Ulang Offline',
            record: 'Aktifkan Rekaman',
            createLink: 'Buat Tautan',
            generatedLink: 'Tautan yang dihasilkan',
            placeholder: 'Silakan klik untuk membuat tautan terlebih dahulu',
            copy: 'Salin',
            copySuccess: 'Tautan telah disalin ke papan klip',
            generateSuccess: 'Tautan berhasil dibuat!',
            generateFail: 'Gagal',
            history: 'Tautan Sejarah',
            all: 'Semua',
            prod: 'Resmi',
            testCategory: 'Uji Coba',
            id: 'ID',
            link: 'Tautan',
            category: 'Kategori',
            type: 'Tipe',
            createTime: 'Waktu Pembuatan',
            disabled: 'Apakah Dinonaktifkan?',
            yes: 'Ya',
            no: 'Tidak',
            version: 'Versi',
            tags: 'Tag',
            // Blokir publikasi saat status selesai
            finishBlockedTitle: 'Tidak Dapat Dipublikasikan',
            finishBlockedMessage: 'Survei telah selesai. Sesuaikan status untuk mempublikasikan.',
            finishBlockedButton: 'Mengerti'
        },
        resourceManagement: {
            resourceManagement: 'Manajemen Sumber Daya',
            title: 'Manajemen Sumber Daya',
            upload: 'Unggah Sumber Daya',
            searchPlaceholder: 'Cari Sumber Daya',
            id: 'ID',
            name: 'Nama Sumber Daya',
            projectId: 'ID Proyek',
            createTime: 'Waktu Pembuatan',
            url: 'Tautan Sumber Daya',
            actions: 'Operasi',
            copyLink: 'Salin Tautan',
            delete: 'Hapus',
            confirmDelete: 'Apakah Anda yakin ingin menghapus sumber daya ini?',
            confirm: 'Peringatan',
            deleteSuccess: 'Berhasil Dihapus',
            deleteFail: 'Gagal Dihapus',
            copySuccess: 'Tautan telah disalin ke papan klip',
            fetchFail: 'Gagal mengambil daftar sumber daya',
            pageTotal: 'Total {total} item',
        },
        resourceUpload: {
            title: 'Unggah Sumber Daya',
            name: 'Nama Sumber Daya',
            namePlaceholder: 'Silakan masukkan nama sumber daya',
            file: 'Lampiran Sumber Daya',
            uploadText: 'Taruh file di sini, atau',
            clickUpload: 'Klik untuk mengunggah',
            uploadTip: 'Perhatikan: Ukuran maksimum 100MB (mendukung jpg, png, pdf, doc, docx, xls, xlsx)',
            cancel: 'Batal',
            confirm: 'Konfirmasi',
            fileTypeError: 'Format file tidak didukung',
            fileSizeError: 'Ukuran file tidak boleh lebih dari 100MB',
            nameRequired: 'Silakan masukkan nama sumber daya',
            fileRequired: 'Silakan pilih file untuk mengunggah',
            uploadSuccess: 'Berhasil Diunggah',
            uploadFail: 'Gagal Diunggah',
            deleteFail: 'Gagal menghapus sumber daya, silakan coba lagi',
        },
    },
    profileView: {
        title: 'Informasi Pribadi',
        back: 'Kembali',
        edit: 'Edit',
        save: 'Simpan',
        cancel: 'Batal',
        username: 'Nama Pengguna',
        avatar: 'Avatar',
        changeAvatar: 'Ganti Avatar',
        email: 'Email',
        phone: 'Nomor Telepon',
        usernameRequired: 'Silakan masukkan nama pengguna',
        usernameLength: 'Panjang 3 hingga 20 karakter',
        emailRequired: 'Silakan masukkan alamat email',
        emailFormat: 'Silakan masukkan alamat email yang benar',
        phoneRequired: 'Silakan masukkan nomor telepon',
        phoneFormat: 'Silakan masukkan nomor telepon yang benar',
        saveSuccess: 'Berhasil Disimpan',
        saveFail: 'Gagal Disimpan',
        avatarTypeError: 'Gambar avatar hanya boleh JPG!',
        avatarSizeError: 'Ukuran gambar avatar tidak boleh lebih dari 2MB!',
    },
    notFound: {
        title: '404',
        pageNotFound: 'Halaman Tidak Ditemukan',
        searching: 'Kami sedang berusaha mencari halaman yang Anda inginkan...',
        backHome: 'Kembali ke Beranda',
    },
    iconSelect: {
        placeholder: 'Silakan masukkan nama ikon',
    },
    tinymce: {
        placeholder: 'Masukkan teks di sini',
    },
    brands: {
        common: {
            all: 'Semua',
            id: 'ID',
            actions: 'Aksi',
            search: 'Cari',
            reset: 'Reset',
            refresh: 'Muat Ulang',
            edit: 'Ubah',
            delete: 'Hapus',
            save: 'Simpan',
            cancel: 'Batal',
            tip: 'Info',
            saveFail: 'Gagal menyimpan',
            deleteFail: 'Gagal menghapus'
        },
        category: {
            title: 'Kategori Merek',
            create: 'Tambah Kategori',
            listTitle: 'Daftar Kategori',
            onlyTop: 'Hanya level 1',
            searchPlaceholder: 'Cari nama kategori',
            parentPlaceholder: 'Kategori level 1',
            childPlaceholder: 'Kategori level 2',
            level1: 'Level 1',
            level2: 'Level 2',
            columns: {
                name: 'Nama Kategori',
                level: 'Level',
                parent: 'Induk'
            },
            createTitle: 'Tambah Kategori',
            editTitle: 'Ubah Kategori',
            deleteConfirmMessage: 'Yakin ingin menghapus kategori ini?',
            form: {
                name: 'Nama Kategori',
                level: 'Level',
                parent: 'Induk',
                levelPlaceholder: 'Pilih level',
                parentPlaceholder: 'Level 2 harus memiliki kategori induk',
                nameRequired: 'Masukkan nama kategori',
                levelRequired: 'Pilih level',
                parentRequired: 'Level 2 harus memiliki kategori induk'
            }
        }
    },
    request: {
        kickedOut: 'Akun Anda masuk di tempat lain, sesi ini telah dikeluarkan. Jika bukan Anda, segera ubah kata sandi.',
        badRequest: 'Parameter permintaan tidak valid. Periksa kembali isian Anda',
        forbidden: 'Anda tidak memiliki izin untuk melakukan tindakan ini',
        notFound: 'Konten yang diminta tidak ada atau telah dihapus',
        timeout: 'Permintaan habis waktu. Periksa jaringan lalu coba lagi',
        payloadTooLarge: 'Unggahan terlalu besar. Kompres lalu coba lagi',
        tooManyRequests: 'Terlalu banyak permintaan. Coba lagi nanti',
        serverError: 'Server gagal memproses permintaan. Coba lagi nanti',
        serviceUnavailable: 'Layanan sementara tidak tersedia. Coba lagi nanti',
        failedWithStatus: 'Permintaan gagal ({status}). Coba lagi nanti',
        networkError: 'Koneksi jaringan bermasalah. Periksa jaringan lalu coba lagi'
    }
}
